import {useSelector} from 'react-redux'
import {
  useLazyContactCountListQuery,
  useLazyContactGetListQuery,
} from '../../../../../services/cellcast.v2'
import {useGetTagsMutation} from '../../../../../services/cellcast.v3'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useCallback, useEffect, useState} from 'react'
import {List} from '../../../../../services/cellcast.v3.types'

type params = {
  page: number
  limit: number
  search: string
}

export function useReadList() {
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [listData, setListData] = useState<List[]>([])
  const [totalData, setTotalData] = useState<number>(0)
  const [totalPage, setTotalPage] = useState<number>(1)
  const [currentPage, setCurrentPage] = useState<number>(1)

  const [fetchData, {data, isLoading, isFetching}] = useLazyContactGetListQuery()
  const [fetchTagsDataRegion, {data: listDataRegion, isLoading: isLoadingRegion}] =
    useGetTagsMutation()
  const [
    fetchCountData,
    {data: countData, isLoading: countDataLoading, isFetching: countDataFetching},
  ] = useLazyContactCountListQuery()

  const fetchListData = useCallback(
    (params?: params) => {
      if (isDefaultRegion) {
        fetchData({
          page: params?.page ?? 1,
          limit: params?.limit ?? 10,
          search: params?.search ?? '',
          usePaginate: true,
        }).then((res) => {
          if ('data' in res && res.data) {
            // load count
            const ids = res.data.data.items.map((el) => el._id)
            if (ids.length > 0) {
              fetchCountData({ids})
            }
          }
        })
      } else {
        let page = params?.page ?? 1
        if (typeof page === 'string') {
          page = parseInt(String(page))
        }

        let limit = params?.limit ?? 1
        if (typeof limit === 'string') {
          limit = parseInt(String(limit))
        }

        fetchTagsDataRegion({
          action: 'find_tag',
          data: {
            page: page ?? 1,
            limit: limit ?? 10,
            search: params?.search ?? '',
            type: 'list',
          },
        })
      }
    },
    [isDefaultRegion]
  )

  useEffect(() => {
    if (data?.data?.items && Array.isArray(data?.data?.items)) {
      setTotalData(data?.data?.total)
      setCurrentPage(data?.data?.current)
      setTotalPage(data?.data?.totalPages)
      setListData(
        data?.data?.items.map((el) => ({
          _id: el._id,
          name: el.name,
          color: el.color,
          type: el.type,
          isHidden: false,
          contactCount: 0,
          createdAt: el?.createdAt,
          updatedAt: el?.updatedAt,
        }))
      )
    }
  }, [data])

  useEffect(() => {
    if (listDataRegion?.data?.items && Array.isArray(listDataRegion?.data?.items)) {
      setTotalData(listDataRegion?.data?.total)
      setCurrentPage(listDataRegion?.data?.current)
      setListData(listDataRegion?.data?.items)
      setTotalPage(listDataRegion?.data?.totalPages)
    }
  }, [listDataRegion])

  return {
    data: listData,
    countData: countData,
    currentPage: currentPage,
    totalData: totalData,
    totalPage: totalPage,
    fetchListData,
    isLoading: isLoading || isFetching || isLoadingRegion,
    isCountLoading: countDataLoading || countDataFetching,
  }
}
